import { IComponentOptions } from 'angular';
import template from './gauge-chart-settings.html';
import controller from './gauge-chart-settings.controller';

import './gauge-chart-settings.scss';

/**
 * @type {IComponentOptions}
 */
const component = {
	template,
	bindings: {
		widget: '<',
		parent: '=',
	},
	transclude: true,
	controller,
};

export default component;
